
/* All Utils
----------------------------------------------------------- */

// Extend Defaults options of a class
export let ExtendDefaults = (source, properties) => {
	let property;
	for (property in properties) {
		if (properties.hasOwnProperty(property)) {
			source[property] = properties[property];
		}
	}
	return source;
}


export let IsInDOM = (id) => new Promise((resolve, reject) => {

	document.addEventListener('DOMContentLoaded', function(){
		const element =  document.getElementById(id);
		if (typeof(element) != 'undefined' && element != null)
		{
			resolve(element);
		} else {
			reject(element);
		}
	}, false);
});
